import { render, staticRenderFns } from "./SmallPaymentMethodSelector.vue?vue&type=template&id=77a44c8b&scoped=true"
import script from "./SmallPaymentMethodSelector.vue?vue&type=script&lang=js"
export * from "./SmallPaymentMethodSelector.vue?vue&type=script&lang=js"
import style0 from "./SmallPaymentMethodSelector.vue?vue&type=style&index=0&id=77a44c8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a44c8b",
  null
  
)

export default component.exports